import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import "./FichaObraMenor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import { getApiInstance } from "../../utils/api";
import { CiCircleCheck, CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";

// Elementos del formulario para documentos
const formElementsDocumentos = [
  {
    elements: [
      {
        name: "obs",
        type: "textarea",
        label: "Descripción",
        placeholder: "Ingrese una descripción del documento",
        required: true,
        disabled: false,
        labelVisible: true,
        visible: true,
      },
      {
        name: "fichero",
        type: "document",
        label: "Documento",
        placeholder: "Subir documento",
        required: true,
        disabled: false,
        labelVisible: true,
        visible: true,
      },
    ],
  },
];

export default function FichaObraMenor() {
  const { id } = useParams();
  const [obraMenor, setObraMenor] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [activeTabGeneral, setActiveTabGeneral] = useState("informacion");
  const [activeTabDatos, setActiveTabDatos] = useState("documentacion");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchObraMenor = async (id) => {
    try {
      const api = getApiInstance();
      const response = await api.get(`/api/ObraMenor/GetObraMenor/${id}`);
      return await response.data;
    } catch (error) {
      console.error("Error fetching gestor:", error);
      throw error;
    }
  };

  const fetchDocumentosObraMenor = async (id) => {
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/ObraMenorDocumento/GetDocumentosFromObraMenor/${id}`
      );
      return await response.data;
    } catch (error) {
      console.error("Error fetching gestor:", error);
      throw error;
    }
  };

useEffect(() => {
  const loadObraMenorData = async () => {
    try {
      setLoading(true);
      setError(null);

      const results = await Promise.allSettled([
        fetchObraMenor(id),
        fetchDocumentosObraMenor(id),
      ]);

      if (results[0].status === 'fulfilled') {
        setObraMenor(results[0].value);
      } else {
        console.error("Error cargando la obra menor:", results[0].reason);
        setError('No se pudo cargar la información principal de la obra menor.');
      }

      if (results[1].status === 'fulfilled') {
        setDocumentos(results[1].value);
      } else {
        console.warn("No se encontraron documentos para la obra:", results[1].reason);
      }

    } catch (err) {
      console.error("Error cargando datos de la obra menor:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (id) {
    loadObraMenorData();
  }
}, [id]);

  const getEstadoBadge = (estado) => {
    const estadoConfig = {
      VALIDADO: { type: "success", label: "Validado" },
      PENDIENTE: { type: "info", label: "Pendiente" },
      INCIDENCIA: { type: "warning", label: "Incidencia" },
      VENCIDO: { type: "error", label: "Vencido" },
      ACTIVA: { type: "success", label: "Activa" },
    };
    return estadoConfig[estado] || estadoConfig["PENDIENTE"];
  };

  const tabsGeneral = [
    { id: "informacion", label: "Información General" },
    { id: "localizacion", label: "Localización" },
  ];

  const tabsDatos = [
    { id: "documentacion", label: "Documentación" }
  ];

  // Configuración de columnas para la tabla de documentos
  const documentosColumns = [
    {
      key: "tipoDocumento",
      label: "Tipo de documento",
      visible: true,
      sortable: true,
    },
    {
      key: "nombreArchivo",
      label: "Documento",
      visible: true,
      sortable: true,
      render: (row) => (
        <a href="#" className="documento-link">
          {row.nombreArchivo}
        </a>
      ),
    },
    {
      key: "validez",
      label: "Validez",
      visible: true,
      sortable: false,
      render: (row) => `${row.fechaValidez}-${row.fechaVencimiento}`,
    },
    {
      key: "estado",
      label: "Validación",
      visible: true,
      sortable: true,
    },
  ];

  const renderInformacionGeneral = () => (
    <div className="ficha-gestor__info">
      <div className="ficha-gestor__field">
        <label>Productor:</label>
        <span>{obraMenor.productor}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Código de obra:</label>
        <span>{obraMenor.nombre}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Fecha inicio:</label>
        <span>{obraMenor.fechaInicio}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Fecha fin:</label>
        <span>{obraMenor.fechaFin}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Empresa intermediaria:</label>
        <span>{obraMenor.intermediario}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Cadena:</label>
        <span>{obraMenor.cadena}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Cantidad generada RP (Kg):</label>
        <span>{obraMenor.cantidadRP}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Cantidad generada RNP (Tn):</label>
        <span>{obraMenor.cantidadNRP}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Observaciones:</label>
        <span>{obraMenor.obs}</span>
      </div>
    </div>
  );

  const renderLocalizacion = () => (
    <div className="ficha-gestor__info">
      <div className="ficha-gestor__field">
        <label>Dirección:</label>
        <span>{obraMenor.direccion}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Localidad:</label>
        <span>{obraMenor.localidad}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Provincia:</label>
        <span>{obraMenor.provincia}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>Comunidad:</label>
        <span>{obraMenor.comunidad}</span>
      </div>
      <div className="ficha-gestor__field">
        <label>País:</label>
        <span>{obraMenor.pais}</span>
      </div>
    </div>
  );

  const renderGeneralContent = () => {
    switch (activeTabGeneral) {
      case "informacion":
        return renderInformacionGeneral();
      case "localizacion":
        return renderLocalizacion();
      default:
        return renderInformacionGeneral();
    }
  };

  const renderDatosContent = () => {
    switch (activeTabDatos) {
      case "documentacion":
        return (
          <div className="ficha-centro__documentacion">
            <Table
              columns={[
                {
                  key: "documento",
                  label: "Documento",
                  visible: true,
                  sortable: true,
                  documentProp: "ficheroBase64",
                  type: "document",
                },
                {
                  key: "obs",
                  label: "Descripción",
                  visible: true,
                  sortable: true,
                },
                {
                  key: "codEstado",
                  label: "Validación",
                  visible: true,
                  sortable: true,
                },
              ]}
              dataTable={documentos}
              noResultsMessage="No hay documentos disponibles"
              rowsPerPage={10}
              showCheckboxes={false}
              actions={["Eliminar"]}
              elementName="Documento"
              keyProp="codDocumento"
              sortProp="documento"
              stateProp="codEstado"
              states={[
                {
                  label: "Sin datos",
                  type: "info",
                  Icon: CiClock1,
                },
                {
                  label: "Pendiente de validar",
                  type: "info",
                  Icon: CiClock1,
                },
                {
                  label: "Validación con incidencias",
                  type: "danger",
                  Icon: CgDanger,
                },
                {
                  label: "Validada",
                  type: "success",
                  Icon: CiCircleCheck,
                },
              ]}
              formElements={formElementsDocumentos}
              addApiUrl="/api/ObraMenorDocumento/SetDocumento"
              deleteApiUrl="/api/ObraMenorDocumento/DeleteDocumento"
              loading={loading}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <DetalleLayout
      title={
        obraMenor
          ? `Obra menor ${obraMenor.nombre} - ${obraMenor.direccion} ${obraMenor.localidad}`
          : "Cargando..."
      }
      backLink="/obras-menores"
      backText="Volver a Obras menores"
      loading={loading}
      error={error}
      notFound={!obraMenor && !loading && !error}
      className="ficha-gestor"
    >
      {!loading && !error && obraMenor && (
        <div className="ficha-gestor__content">
          <div className="ficha-gestor__section">
            <div className="ficha-gestor__section-header">
              <h2>Información General</h2>
            </div>

            <TabsNavigation
              tabs={tabsGeneral}
              activeTab={activeTabGeneral}
              onTabChange={setActiveTabGeneral}
            />

            <div className="ficha-gestor__section-content">
              {renderGeneralContent()}
            </div>
          </div>

          <div className="ficha-gestor__section">
            <div className="ficha-gestor__section-header">
              <h2>Datos de la obra menor</h2>
            </div>

            <TabsNavigation
              tabs={tabsDatos}
              activeTab={activeTabDatos}
              onTabChange={setActiveTabDatos}
            />

            <div className="ficha-gestor__section-content">
              {renderDatosContent()}
            </div>
          </div>
        </div>
      )}
    </DetalleLayout>
  );
}
